module.exports = __webpack_public_path__ + "static/media/agent8.5627f88d.png";